<template>
  <div id="wiki-page-tutorial">
    <v-layout column>
      <v-flex><h1>{{ WikiTutorials.title }}</h1></v-flex>
      <v-flex><p>{{ WikiTutorials.introduction }}</p></v-flex>
    </v-layout>
    
    <v-layout column>
      <v-flex><h2>{{ WikiTutorials.toc.title }}</h2></v-flex>
      <v-flex>
        <ol>
          <template v-for="c in WikiTutorials.toc.content">
            <li :key="c">{{ c }}</li>
          </template>
        </ol>
      </v-flex>
    </v-layout>
    
    <template v-for="section in WikiTutorials.sections">
      <v-layout :key="section.id" column>
        <v-flex><h2>{{ section.title }}</h2></v-flex>
        <v-flex>
          <template v-for="c in section.content">
            <p :key="c">{{ c }}</p>
          </template>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import WikiStore from '../../../stores/WikiStore'

export default {
  data () {
    return {
      WikiTutorials: WikiStore.data.Tutorials.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/wiki/pages/Tutorials.vue